import useTranslation from "next-translate/useTranslation"
import { FormControl } from "../../Form/FormControl/FormControl"
import { Label } from "../../Form/Inputs/Label"
import { TagSelect } from "./TagSelect"

export const TagsSelectForm = ({ tags, setTags }: any) => {
    const { t } = useTranslation('create');

    return (
            <>
            <Label className="text-base block my-[12px] sm:mt-0 ml-[15px]" label={t('tags.title')} />
            <TagSelect tags={tags} setTags={setTags} />
            </>
    )
}